import { render, staticRenderFns } from "./ListImportProduct.vue?vue&type=template&id=4d51f78d&"
import script from "./ListImportProduct.vue?vue&type=script&lang=js&"
export * from "./ListImportProduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports